var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3335 25V23L11.3335 22H8.3335C7.7835 22 7.31283 21.8043 6.9215 21.413C6.5295 21.021 6.3335 20.55 6.3335 20V9C6.3335 8.45 6.5295 7.979 6.9215 7.587C7.31283 7.19567 7.7835 7 8.3335 7H16.3335V9H8.3335V20H24.3335V17H26.3335V20C26.3335 20.55 26.1378 21.021 25.7465 21.413C25.3545 21.8043 24.8835 22 24.3335 22H21.3335L22.3335 23V25H10.3335ZM19.3335 19L14.3335 14L15.7335 12.6L18.3335 15.175V7H20.3335V15.175L22.9335 12.6L24.3335 14L19.3335 19Z",
    fill: "#0068A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdates);
export default __webpack_public_path__ + "static/media/updates.b344306ec80d979efc7bbd94372a6e9c.svg";
export { ForwardRef as ReactComponent };